import { fetchPerms } from '../../api/auth'
import { isWorkflowEditable } from '../../utils/workflow'

export default {
  data() {
    return {
      headStyle: { background: '#f5f7fa', color: '#606266' },
      permCodes: [],
      loading: false
    }
  },
  computed: {
    canEditDoc() {
      const form = this.form || {}
      return isWorkflowEditable(form.workflowStatus, form.approveStatus)
    }
  },
  created() {
    this.loadPerms()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() {
      fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    },
    today() {
      const d = new Date()
      const p = n => String(n).padStart(2, '0')
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
    },
    money(v) {
      const n = Number(v || 0)
      return Number.isFinite(n) ? n.toFixed(2) : ''
    },
    assertCanEditDoc(action) {
      if (this.canEditDoc) return true
      this.$message.warning(action === 'delete'
        ? '审批中或已审核的单据不可删除'
        : '审批中或已审核的单据不可修改')
      return false
    }
  }
}
